import { Box } from '@mui/material'
import React from 'react'
import FlashCardLink from "../../Components/FlashCard/FlashCardLink";
import FlashCard from "../../Components/FlashCard/FlashCard";

function FlashCardPage() {
  return (
    <Box>
         <FlashCardLink/>
           <FlashCard/>
    </Box>
  )
}

export default FlashCardPage